import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";

import * as fromServices from "../services";

/**
 * check if user is not authenticated navigate to /auth/login with queryParams having current url
 * and pass it if authenticated
 *
 * @export
 * @class AuthGuardService
 * @implements {CanActivate}
 */
@Injectable({
  providedIn: "root",
})
export class AuthGuardService implements CanActivate {
  constructor(
    private auth: fromServices.AuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    // QSL-10367: the gated-orb Siraj landings (Wird, Shoab) are public-friendly.
    // The mobile webview contract pins them at /siraj/{screen} (NOT /siraj/guest),
    // and each page renders its OWN "log in first" state for guests. Let them
    // through so a logged-out orb tap is NOT bounced to /auth/login — which, when
    // routed via /siraj/guest, also broke iOS WKWebView ("outside the sandbox").
    if (/^\/siraj\/(wird|shoab)(\?|$|\/)/.test(state.url || "")) {
      return true;
    }
    if (!this.auth.isAuthenticated()) {
      this.router.navigate(["/auth/login"], {
        queryParams: { redirectURL: state.url },
      });
      return false;
    }
    return true;
  }
}
